/* global Event */
import React, { Component } from "react";
import { object } from "prop-types";
import moment from "moment";
import "moment/locale/pt-br";
import { Tabs, Tab, Row, Col, Panel } from "react-bootstrap";
import classNames from "classnames";
import LazyLoad from "react-lazy-load";
import { connect } from "react-redux";

import Header from "./Header";
import TimeframeChooser from "./TimeframeChooser";
import TagFilter from "./TagFilter";
import _ from "lodash";

// import DailyFunnelChart from './charts/DailyFunnelChart'
// import AppropriatedCount from './charts/AppropriatedCount'
// import EngagementChart from "./charts/EngagementChart";
// import PlayBounceChart from "./charts/PlayBounceChart";
// import TimeToPlayChart from "./charts/TimeToPlayChart";
// import DailyPlayBounceChart from "./charts/DailyPlayBounceChart";
// import ConversionUsersTable from "./charts/ConversionUsersTable";
// import FunnelOnTableWithFilters from "./charts/Funnels/FunnelOnTableWithFilters";
// import FrequencyToPlayChart from "./charts/FrequencyToPlayChart";
// import ABTestStats from "./charts/ABTestStats";
import FunnelChartLoader from "./charts/FunnelChartLoader";
import DailyFunnelLoader from "./charts/DailyFunnelLoader";
// import ComparativeFunnel from "./charts/ComparativeFunnel";
// import NPSChart from "./charts/NPSChart";
// import NPSChartDaily from "./charts/NPSChartDaily";
// import ConversionUsersTableNew from "./charts/ConversionUsersTableNew";
// import ConversionUsersTableGuide from "./charts/ConversionUsersTableGuide";
// import EngagementTable from "./charts/EngagementTable";
// import EngagementPerInteractives from "./charts/EngagementPerInteractives";
// import FlowChart from "./charts/FlowChart";
import SessionStepsTable from "./charts/SessionStepsTable";
import BarFunnel from "./charts/BarFunnel";

// import Restricted from "./Restricted";

import "react-datepicker/dist/react-datepicker.css";
import BarFunnelByViewer from "./charts/BarFunnelByViewer";
import Cohort from "./charts/Cohort";

class CampaignStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      campaign: {},
      filters: []
    };

    this.handleClickButtonCampaign = this.handleClickButtonCampaign.bind(this);
    this.handleClickButtonVideo = this.handleClickButtonVideo.bind(this);
    this.tabChanged = this.tabChanged.bind(this);
    this.buildFilters = this.buildFilters.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.buildFilters(nextProps);
  }
  componentWillMount() {
    this.buildFilters(this.props);
    let campaign = this.props.campaign;
    let changedCampaign = Object.assign({}, campaign, {
      events: true,
      people: false
    });
    changedCampaign.videos.forEach(video => {
      Object.assign(video, { events: true, people: false });
    });

    this.setState({
      campaign: changedCampaign
    });
  }
  handleClickButtonCampaign(e, type) {
    e.preventDefault();
    let campaign = {
      ...this.state.campaign,
      people: false,
      events: false,
      [type]: true
    };
    this.setState({ campaign });
    window.dispatchEvent(new Event("resize"));
  }
  handleClickButtonVideo(e, videoId, type) {
    e.preventDefault();
    let updatedVideos = this.state.campaign.videos.map(video => {
      if (video.id === videoId) {
        video["events"] = false;
        video["people"] = false;
        video[type] = true;
      }
      return video;
    });
    let campaign = {
      ...this.state.campaign,
      videos: updatedVideos
    };
    this.setState({ campaign });
    window.dispatchEvent(new Event("resize"));
  }
  tabChanged() {
    // Necessário pois o gráfico buga e sai da div.
    // Com isso ele redimensiona para caber.
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 2000);
  }
  buildFilters(props) {
    let filters = [];

    if (props.tagFilter.selectedTags.length > 0) {
      filters.push(props.tagFilter.filter);
    }

    this.setState({
      filters
    });
  }
  render() {
    let { campaign, filters } = this.state;
    const { location, timeframeChooser, user } = this.props;
    return (
      <div className="container">
        <Row>
          <Col md={12}>
            <div className="page-header">
              <Row>
                <Col md={12}>
                  <h2 className="mt26">{this.state.campaign.name}</h2>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mt26">
            <TagFilter campaign={campaign} />
          </Col>
          <Col md={6}>
            <TimeframeChooser location={location} campaign={campaign} />
          </Col>
        </Row>
        {/* Mostrando somente para videos GUIDE, pois tem versão horizontal & vertical */}
        {this.state.campaign.videos.length > 1 &&
          (this.state.campaign.id === "5a3d0e8049e63e00068f87b9" ||
            this.state.campaign.id === "5a2aeac7ae8238000a3dc01e") && (
            <Row key={this.state.campaign.id}>
              <Col md={12}>
                <div className="page-header">
                  <h2>Geral</h2>
                </div>
              </Col>
              <Col md={12}>
                <Tabs defaultActiveKey={10} id={`${this.state.campaign.id}-tabs`} onSelect={this.tabChanged}>
                  <Tab eventKey={1} title="Acumulado">
                    <Row>
                      <Col md={6}>
                        <Panel header="Eventos">
                          <Row>
                            <Col md={12}>
                              <LazyLoad>
                                <FunnelChartLoader
                                  actor="eventos"
                                  campaign={this.state.campaign}
                                  funnelType={this.state.campaign.funnel_type}
                                  timeframe={timeframeChooser.timeframe}
                                  filters={filters}
                                />
                              </LazyLoad>
                            </Col>
                          </Row>
                        </Panel>
                      </Col>
                      <Col md={6}>
                        <Panel header="Pessoas">
                          <Row>
                            <Col md={12}>
                              <LazyLoad>
                                <FunnelChartLoader
                                  actor="pessoas"
                                  campaign={this.state.campaign}
                                  funnelType={this.state.campaign.funnel_type}
                                  timeframe={timeframeChooser.timeframe}
                                  filters={filters}
                                />
                              </LazyLoad>
                            </Col>
                          </Row>
                        </Panel>
                      </Col>
                    </Row>
                  </Tab>
                  {false && (
                    <Tab eventKey={2} title="Diário">
                      <Row>
                        <Col md={2}>
                          <button
                            className={classNames({
                              "btn btn-block btn-primary": true,
                              active: this.state.campaign.events
                            })}
                            href="#"
                            onClick={e => {
                              this.handleClickButtonCampaign(e, "events");
                            }}
                          >
                            Eventos
                          </button>
                          <button
                            className={classNames({
                              "btn btn-block btn-primary": true,
                              active: this.state.campaign.people
                            })}
                            href="#"
                            onClick={e => {
                              this.handleClickButtonCampaign(e, "people");
                            }}
                          >
                            Pessoas
                          </button>
                        </Col>
                        <Col md={10}>
                          <div id="campaign-daily-events" className={this.state.campaign.events ? "" : "hidden"}>
                            <Panel header="Eventos">
                              <LazyLoad>
                                <DailyFunnelLoader
                                  actor="eventos"
                                  campaign={this.state.campaign}
                                  timeframe={timeframeChooser.timeframe}
                                  filters={filters}
                                />
                              </LazyLoad>
                            </Panel>
                          </div>
                          <div id="campaign-daily-people" className={this.state.campaign.people ? "" : "hidden"}>
                            <Panel header="Pessoas">
                              <LazyLoad>
                                <DailyFunnelLoader
                                  actor="pessoas"
                                  campaign={this.state.campaign}
                                  timeframe={timeframeChooser.timeframe}
                                  filters={filters}
                                />
                              </LazyLoad>
                            </Panel>
                          </div>
                        </Col>
                      </Row>
                    </Tab>
                  )}
                </Tabs>
              </Col>
            </Row>
          )}

        {this.state.campaign.videos.map(video => {
          if (video.ready) {
            return (
              <div key={video.id}>
                <Row>
                  <Header
                    title={`${video.title} - ${moment(timeframeChooser.startDate).format("DD/MM")} a ${moment(
                      timeframeChooser.endDate
                    ).format("DD/MM")}`}
                  />
                </Row>
                <Row>
                  <Col md={12}>
                    <Tabs defaultActiveKey={4} id={`${video.id}-tabs`} onSelect={this.tabChanged}>
                      {/* <Tab eventKey={1} title="Flow">
                        <Row>
                          <Col md={12}>
                            <LazyLoad>
                              <FlowChart video={video} timeframe={timeframeChooser.timeframe} />
                            </LazyLoad>
                          </Col>
                        </Row>
                      </Tab> */}

                      {/* {_.includes(["overmedia", "admin"], user.profile) && ( */}
                      <Tab eventKey={2} title="Tabelão">
                        <Row>
                          <Col md={12}>
                            <SessionStepsTable video={video} timeframe={timeframeChooser.timeframe} user={user} />
                          </Col>
                        </Row>
                      </Tab>
                      {/* )} */}

                      {/* {_.includes(["overmedia", "admin"], user.profile) && ( */}
                      <Tab eventKey={3} title="Funil">
                        <Row>
                          <Col md={12}>
                            <BarFunnel video={video} timeframe={timeframeChooser.timeframe} />
                          </Col>
                        </Row>
                      </Tab>

                      <Tab eventKey={4} title="Funil por pessoa">
                        <Row>
                          <Col md={12}>
                            <BarFunnelByViewer video={video} timeframe={timeframeChooser.timeframe} />
                          </Col>
                        </Row>
                      </Tab>

                      {/* )} */}
                      {_.includes(["overmedia", "admin"], user.profile) && (
                        <Tab eventKey={5} title="Cohort">
                          <Row>
                            <Col md={12}>
                              <Cohort video={video} timeframe={timeframeChooser.timeframe} />
                            </Col>
                          </Row>
                        </Tab>
                      )}
                    </Tabs>
                  </Col>
                </Row>
              </div>
            );
          } else {
            return (
              <p key={video.id}>
                Estatísticas para o vídeo <strong>{video.title}</strong> ainda não estão disponíveis.
              </p>
            );
          }
        })}
      </div>
    );
  }
}

CampaignStats.propTypes = {
  campaign: object,
  location: object,
  timeframeChooser: object
};

const mapStateToProps = state => {
  return {
    tagFilter: state.tagFilter
  };
};

export default connect(mapStateToProps, null)(CampaignStats);



// WEBPACK FOOTER //
// ./src/components/CampaignStats.js